import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import defaultImage from '../../assets/default.jpg';
import share from '../../assets/share.png';

export default ({listInfoGraphic, baseURL}) => {
  return (
    <section className="psre-empat-satu">
      <div className="container">
        <table className="table-borderless w-100 mb-5">
          <tr>
            <td>
              <p className="mb-0" style={{fontSize: '14px', fontWeight: '600'}}>Ruang Infografik dan Materi</p>
            </td>
            <td className="tb" style={{width: '65%'}}>
              <div style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width: '100%'}}></div>
            </td>
            <td class="text-right">
              <Link to='/event/infographic' style={{fontSize: '13px', fontWeight: '600', color: '#0085C'}}>Lihat Semua Infografik</Link>
            </td>
          </tr>
        </table>
        <div className="row" style={{flexWrap: 'nowrap', overflowX: 'auto'}}>
          {listInfoGraphic.length ? listInfoGraphic.map(e=>(
            <div className="col-lg-3 col-md-3 col-sm-10 col-10"><img className="mb-4" src={e.thumbnail ? baseURL + '/' + e.thumbnail : defaultImage} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
              <p style={{fontSize: '16px', fontWeight: '600'}}>{e.title}</p>
              <div style={{fontSize: '12px', marginBottom: '25px'}}>
                <p className="text-muted mb-1">Kategori Infografik</p>
                <p className="text-muted mb-1">{e.source}</p>
              </div>
              <div className="d-flex"><a className="btn btn-blue" href={e.url} target="_blank" style={{fontSize: '13px', padding: '9px 30px !important'}}>Download</a><a href=""><img className="ml-4" src={share} alt="share" style={{width: '23px', height: '23px', marginTop: '7px'}} /></a></div>
            </div>
          )) : <div>No Data Founded</div>}
        </div>
      </div>
    </section>
  )
}

